import { NoImage } from 'macaron-frontend-ui'
import type { FC } from 'react'
import Image from '~/components/image/Image'
import { PPG_COURSE_NOIMAGE_URL } from '~/lib/constants/constants'
import { css, cx } from '~/styled-system/css'

type Props = {
  width: number
  height: number
  className?: string
}

const PpgCourseNoImage: React.FC<Props> = ({ width, height, className }: Props) => {
  return (
    <Image
      alt=""
      src={PPG_COURSE_NOIMAGE_URL}
      width={width}
      height={height}
      className={cx(className, css({ rounded: 'sm' }))}
    />
  )
}

export const CourseNoImage: FC<Props> =
  import.meta.env.VITE_MODE === 'ppg' ? PpgCourseNoImage : NoImage
